export default class ItemIdsObserver {
  constructor(context) {
    this.context = context;
  }

  onBroadcast() {}

  onBroadcastDelete() {}
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/item_ids_observer.js